import { type ComponentProps, type ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'
import { itemTitleClasses } from '../styles'

interface ItemTitleProps extends ComponentProps<'span'> {
  /** A Badge after the text. The text truncates first, so the badge is never pushed off the row. */
  badge?: ReactNode
}

/** The row's name, on one line. */
function ItemTitle({ className, badge, children, ...props }: ItemTitleProps) {
  return (
    <span
      data-slot="item-title"
      className={twMerge(
        itemTitleClasses,
        'group-data-[disabled]/item:text-foreground-disabled flex min-w-0 items-center gap-2',
        className,
      )}
      {...props}
    >
      <span className="truncate">{children}</span>
      {badge && <span className="flex flex-none items-center">{badge}</span>}
    </span>
  )
}

export { ItemTitle }
export type { ItemTitleProps }
